<template>
  <b-modal
    id="member-delete-modal"
    ref="memberDeleteModal"
    modal-class="delete-modal"
    size="sm">
    <div class="text-center">
      <h5>Are you sure you want to remove this member?</h5>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
      <b-button
        :disabled="deleting"
        @click="commitDelete">
        Yes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MemberDeleteModal',
  props: {
    memberp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    ...mapGetters({
      memberDeleted: 'merchant/memberDeleted',
      apiError: 'merchant/apiError',
    }),
  },
  watch: {
    memberDeleted(deleted) {
      if (deleted) {
        this.deleting = false;
        this.$emit('deleted', deleted);
        this.$refs.memberDeleteModal.hide();
      }
    },
  },
  methods: {
    ...mapActions({
      deleteMember: 'merchant/deleteMember',
    }),
    commitDelete() {
      this.deleting = true;
      this.deleteMember({
        merchant_id: this.$route.params.merchant_id,
        member_id: this.memberp.id,
      });
    },
    show() {
      this.$refs.memberDeleteModal.show();
    },
    hide() {
      this.deleting = false;
      this.$refs.memberDeleteModal.hide();
    },
  },
};
</script>
